import { render, staticRenderFns } from "./TransferSymbolicAmount.vue?vue&type=template&id=8b4b938a&"
import script from "./TransferSymbolicAmount.vue?vue&type=script&lang=js&"
export * from "./TransferSymbolicAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports